"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var React = _interopRequireWildcard(_react);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function SvgWarning(props) {
    return React.createElement(
        "svg",
        Object.assign({
            xmlns: "http://www.w3.org/2000/svg",
            width: 24,
            height: 24,
            viewBox: "0 0 24 24",
            fill: "currentColor"
        }, props),
        React.createElement(
            "g",
            { fill: "none", fillRule: "evenodd" },
            React.createElement("path", {
                fill: "currentColor",
                d: "M2.24 19.25c-.555.959-.115 1.736.986 1.736h18.018c1.1 0 1.546-.768.986-1.736L13.24 3.723c-.555-.96-1.45-.968-2.01 0L2.24 19.25zm10.995-1.264h-2v-2h2v2zm0-4h-2v-4h2v4z"
            })
        )
    );
}
exports.default = SvgWarning;